import { useNavigate, useParams } from "react-router-dom";

import { useGetAttemptByIdQuery } from "../../slices/quizAttemptApiSlice";

import ResultSummaryCard from "./components/ResultSummaryCard";
import AnswerReviewList from "./components/AnswerReviewList";
import { useState } from "react";
import ExplanationModal from "./components/ExplanationModal";

const QuizResultScreen = () => {
  const navigate = useNavigate();

  const { id: attemptId } = useParams();

  const {
    data: attemptResponse,
    isLoading,
    isError,
  } = useGetAttemptByIdQuery(attemptId, {
    skip: !attemptId,
  });

  const [selectedExplanation, setSelectedExplanation] = useState("");
const [showExplanation, setShowExplanation] = useState(false);

const handleOpenExplanation = (explanation) => {
  setSelectedExplanation(explanation || "");
  setShowExplanation(true);
};

const handleCloseExplanation = () => {
  setShowExplanation(false);
  setSelectedExplanation("");
};

  // Supports both:
  // { attempt: {...} }
  // OR direct attempt object response

  const attempt =
    attemptResponse?.attempt || attemptResponse?.data || attemptResponse;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Loading result...</p>
      </div>
    );
  }

  if (isError || !attempt) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-800">
            Result not available
          </h2>

          <button
            type="button"
            onClick={() => navigate("/student/quizzes")}
            className="
              mt-4
              px-5
              py-2
              bg-blue-600
              text-white
              rounded-lg
            "
          >
            Back to Attempts
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Page Header */}

        <div className="bg-white rounded-lg border p-5">
          <h1 className="text-2xl font-bold text-gray-800">Quiz Result</h1>

          <p className="text-gray-500 mt-1">{attempt.quiz?.name || "Quiz"}</p>
        </div>

        {/* Result Summary */}

        <ResultSummaryCard
          obtainedMarks={attempt.obtainedMarks}
          totalMarks={attempt.totalMarks}
          percentage={attempt.percentage}
          result={attempt.result}
          correctAnswers={attempt.correctAnswers}
          wrongAnswers={attempt.wrongAnswers}
          unansweredQuestions={attempt.unansweredQuestions}
          durationSeconds={attempt.durationSeconds}
        />

        {/* Actions */}

        <div className="flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => navigate("/student/attempts")}
            className="
              px-5
              py-2
              rounded-lg
              border
              bg-white
              text-gray-700
              hover:bg-gray-50
            "
          >
            My Attempts
          </button>

          {attempt.quiz?._id && (
            <button
              type="button"
              onClick={() =>
                navigate(`/student/quizzes/${attempt.quiz._id}/start`)
              }
              className="
                px-5
                py-2
                rounded-lg
                bg-blue-600
                text-white
                hover:bg-blue-700
              "
            >
              Practice Again
            </button>
          )}
        </div>

        {/* Answer Review */}

        <AnswerReviewList
  answers={attempt.answers || []}
  onShowExplanation={handleOpenExplanation}
/>
<ExplanationModal
  isOpen={showExplanation}
  explanation={selectedExplanation}
  onClose={handleCloseExplanation}
/>
      </div>
    </div>
  );
};

export default QuizResultScreen;
